import moment from 'moment'

export const columnsData = [
    {
        Header: 'Open Date',
        accessor: 'ticketOpenDate',
        Cell: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm'),
    },
    {
        Header: 'Opened By',
        accessor: 'ticketType',
        Cell: ({ value }) => {
            const INITIATORS = {
                ['supplier-to-user']: 'Supplier',
                ['admin-to-both']: 'Admin',
                default: 'User',
            }
            return INITIATORS[value] || INITIATORS.default
        },
    },
    {
        Header: 'Close Date',
        accessor: 'ticketCloseDate',
        Cell: ({ value }) => (value ? moment(value).format('DD/MM/YYYY HH:mm') : null),
    },
    {
        Header: 'Closed By',
        accessor: 'ticketClosedBy',
    },
    {
        Header: 'Ticket Subject',
        accessor: 'ticketSubject',
        width: 300,
    },
    {
        id: 'expander',
        Cell: ({ row }) => <span className="expanderButton">{row.isExpanded ? '▲' : '▼'}</span>,
        width: 50,
    },
]
